export const meta = {
  title: 'Getting started: from signup to your first ticket',
  updatedAt: '2026-07-17',
  related: ['queue-board', 'pos', 'billing'],
};

Your carwash can be live before your coffee cools. This walkthrough takes you from the signup form to your first collected ticket.

## 1. Sign up — 30 seconds, no card

Head to the **Sign up** page and fill in four things: your business name, your name, your email, and a password. If a sales agent introduced you, their code is either already attached to your link or you can type it in — it never changes what you pay.

Submitting activates your account instantly: a **14-day free trial** with full access, no card required. You're signed in and land on your dashboard right away.

## 2. The welcome wizard

The first time you open the dashboard, a four-step wizard sets up the essentials:

1. **Confirm your outlet** — name and address, as customers should see them.
2. **Business hours** — your weekly open and close times.
3. **Your logo** — upload it and we generate the full icon set for your customer app. You can skip this and add it later from Branding, but until then customers see a placeholder.
4. **Your welcome card** — trial countdown, your customer-app link, and an **Open queue** button.

Finish, and you're on the queue board — the screen your team will live on.

## 3. Put your QR where customers stand

Open **Print QR** from the queue header. It gives you a print-ready QR code for your outlet. Stick it at the entrance, the counter, anywhere a driver waits.

When a customer scans it, they open **your** web app — your name, your colours, your logo. They pick a wash package, choose their vehicle type, type their plate number, and join the queue. No app store, no download.

## 4. Your first ticket

The moment a customer books, a ticket appears in the **In queue** column of your queue board with a short ticket number and their plate. New tickets join the end of the line.

Work it across the board:

- Tap **Start** when the car enters the bay — the customer's ticket moves to _In washing process_.
- Tap **Ready** when the wash is done — the customer gets a notification that their car is ready.
- The ticket now waits in _Ready for collection_ for payment.

## 5. Collect payment at the POS

Open the **POS** screen. Every ticket that's ready for collection is listed. Tap the ticket, pick how the customer pays — cash, DuitNow QR, TNG, GrabPay, card, bank transfer, voucher, or free — and confirm. The ticket archives into history and the customer's loyalty points are awarded on the spot.

That's the full loop: scan → queue → wash → ready → paid. Everything after this — loyalty, vouchers, marketing — builds on those tickets.

## Where to next

Read **The queue board** for reordering, holds, and multi-outlet switching, and **Billing & your subscription** for how the trial rolls into your first invoice.
